
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import 'jquery-ui/ui/widgets/autocomplete.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/selectmenu.js';
import 'jquery-ui/ui/widgets/dialog.js';
import 'jquery-ui.combobox/lib/jquery-ui.combobox.js';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import * as FilePond from 'filepond';
window.FilePond = FilePond;
require('jquery-filepond/filepond.jquery.js');
import 'filepond/dist/filepond.min.css';

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/js/sw.js")
        .then(reg => console.log("Service Worker registered: ", reg))
        .catch(err => console.error("Service Worker registration failed: ", err));
    });
  }


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
